<template>
    <el-dialog
    :visible="visible"
    :title="title"
    custom-class="codelab-popper codelab-media-manager"
    :show-close="false"
    :append-to-body="true"
    :before-close="close"
    width="600px"
    >
        <div slot="footer">
            <template v-if="!showSoundRecord">
                <span class="popper-footer-button codelab-button gray" @click="close" tabindex="4">{{$t("button.cancel")}}</span>
                <span class="popper-footer-button codelab-button blue" @click="confirm(!selectedMedia)" :class="{'disabled': !selectedMedia}" tabindex="3">{{$t("button.ok")}}</span>
            </template>
            <template v-else>
                <span class="popper-footer-button codelab-button blue" @click="uploadRecord" :class="{'disabled': !canUploadRecord}" tabindex="3">{{$t("button.add_record")}}</span>
            </template>
        </div>
        <div class="media-container" :style="{marginLeft: (showSoundRecord ? '-100%' : 0)}">
            <el-scrollbar class="media-list-wrapper" ref="scrollBar">
                <ul :class="['media-list',listType]">
                    <li class="add-item">
                        <span class="add-custom-media" @click.stop="openAddMaterialPopper">
                            <span class="button">
                                <svg-icon href="#codelab-add" :width="listType === 'list' ? 40 : 48" :height="listType === 'list' ? 40 : 48"></svg-icon>
                                <span class="label" v-if="type === 'audio'">{{$t("text_upload_record")}}</span>
                            </span>
                        </span>
                        <span v-if="type === 'audio'" style="border-left:2px solid #444444;" class="add-custom-media" @click.stop="startAddSoundRecord">
                            <span class="button">
                                <svg-icon href="#codelab-record-add" style="margin-top: 4px;" :width="40" :height="40"></svg-icon>
                                <span class="label" v-if="type === 'audio'">{{$t("text_record")}}</span>
                            </span>
                        </span>
                    </li>
                    <li class="list-header" v-if="type === 'audio'">
                        <span class="delete"></span>
                        <span class="name">{{$t("material_name")}}</span>
                        <span class="format">{{$t("material_format")}}</span>
                        <span class="duration">{{$t("material_duration")}}</span>
                    </li>
                    <li v-for="item in typedUploadingMedias" :data-sid="item.sId" :key="item.sId">
                        <media-uploader
                        :media="item"
                        :type="listType"
                        ></media-uploader>
                    </li>
                    <li v-for="item in mediaList" 
                    :class="{'selected':(mediaIndex === item.index && !selectedMedia) || (selectedMedia && selectedMedia.url === item.url)}" 
                    :key="item.projectMaterialId" 
                    @click="onMediaSelect(item, mediaIndex === item.index)"
                    @dblclick="confirm(mediaIndex === item.index)"
                    >
                        <template v-if="listType === 'card'">
                            <div class="media-thumb">
                                <img v-if="type === 'photo' || type === 'video'" :src="util$.formatUrlWithToken$(item.screenshot)"/>
                                <span class="delete-media" v-if="!usedCustomMediaIndexs.includes(item.index)" @click.stop="beforeDeleteMaterial(item)">
                                    <svg-icon href="#material-list-icon-delete" :width="24" :height="24"></svg-icon>
                                </span>
                            </div>
                            <div class="media-name">{{item.index || item.metadata.title}}</div>
                        </template>
                        <template v-else>
                            <span class="delete">
                                <span class="delete-media" v-if="!usedCustomMediaIndexs.includes(item.index)" @click.stop="beforeDeleteMaterial(item)">
                                    <svg-icon href="#material-list-icon-delete" :width="24" :height="24"></svg-icon>
                                </span>
                            </span>
                            <span class="name">{{item.index || item.metadata.title}}</span>
                            <span class="format">{{getMaterialFormat(item) || $t("unknown")}}</span>
                            <span class="duration">{{getDurationText(item.metadata.duration) || $t("unknown")}}</span>
                        </template>
                    </li>
                </ul>
            </el-scrollbar>
        </div>
        <sound-record ref="soundRecorder" :visible.sync="showSoundRecord" @statusChange="onRecorderStatusChange" class="media-container"></sound-record>
        <add-material-popper
        ref="fileSelector"
        :material-type="type"
        @confirm="addMedia2Project"
        ></add-material-popper>
    </el-dialog>
</template>
<script>
import addMaterialPopper from "./add-material-popper.vue";
import soundRecord from "@/code-lab/component/sound-record.vue";
import mediaUploader from "./media-uploader.vue";
import utils from "@/service/utils";
import { mapState } from 'vuex';
const Cookies = window.Cookies;
export default {
    name: "media-manager",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: "photo"
        },
        mediaIndex: String
    },
    data(){
        return {
            uploadingMedias:[],
            selectedMedia: null,
            showSoundRecord: false,
            canUploadRecord: false,
            //使用用户自定义素材的块
            customMediaBlockTypes: [
                "other_function_camera",
                "other_function_video",
                "sound_record"
            ],
            usedCustomMediaIndexs: []
        }
    },
    computed: {
        ...mapState('user', [
            'teamId'
        ]),
        ...mapState({
            workSpace: "workSpace",
            projectId: state => state.projectData.projectId,
            materials: state => state.materialsList.filter(item => !!item && !item.ref),
            isMissionProject: state => state.selectedMenue === "mission" && state.currentMission,
        }),
        listType(){
            return ["audio", "record"].includes(this.type) ? "list" : "card";
        },
        title(){
            return this.type? this.$t("popper_title." + this.type): "";
        },
        mediaList(){
            let materials = this.materials;
            if(!materials){
                return [];
            }
            if(this.type === "video"){
                return materials.filter(item => this.isVideo(item.url));
            } else if(this.type === "photo"){
                return materials.filter(item => this.isImg(item.url));
            } else if(this.type === "audio"){
                return materials.filter(item => this.isAudio(item.url));
            } else if(this.type === "record"){
                return materials.filter(item => this.isRecord(item.url));
            } else {
                return [];
            }
        },
        typedUploadingMedias(){
            return this.uploadingMedias.filter(item => item.mediaType === this.type);
        }
    },
    watch: {
        visible(value){
            if(value){
                this.selectedMedia = null;
            }
        }
    },
    mounted(){
        this.usedCustomMediaIndexs = this.getCustomMediaBlockIndexs();
    },
    methods: {
        onMediaSelect(media, disabled){
            if(!disabled){
                this.selectedMedia = media;
            }
        },
        close(){
            this.$emit("close");
        },
        confirm(disabled){
            if(!disabled){
                if(this.selectedMedia){
                    if(this.mediaIndex === this.selectedMedia.index){
                        this.close();
                    } else {
                        this.$emit("confirm", this.selectedMedia);
                    }
                    
                }
            }
        },
        openAddMaterialPopper(){
            if(this.projectId){
                this.$refs["fileSelector"] && this.$refs["fileSelector"].startSelectFile();
            } else {
                if(this.isMissionProject){
                    this.$message.info(this.$t("message.warn_forbidden_upload_material_mission"));
                } else {
                    this.$message.info(this.$t("message.warn_forbidden_upload_material_project"));
                }
            }
        },
        startAddSoundRecord(){
            if(!this.projectId){
                if(this.isMissionProject){
                    this.$message.info(this.$t("message.warn_forbidden_upload_record_mission"));
                } else {
                    this.$message.info(this.$t("message.warn_forbidden_upload_record_project"));
                }
                return;
            }
            this.showSoundRecord = true;
        },
        onRecorderStatusChange(status){
            this.canUploadRecord = status >= 2;
        },
        uploadRecord(){
            if(!this.canUploadRecord){
                return;
            }
            console.log("uploadRecord");
            let soundRecorder = this.$refs.soundRecorder;
            if(soundRecorder){
                soundRecorder.back();
                let wavBlob = soundRecorder.getWavBlob();
                if(!wavBlob){
                    return;
                }
                let fileName = utils.getRandomId$("rec").substr(0, 6) + ".wav";
                let file = new File([wavBlob], fileName, {type: wavBlob.type, lastModified: Date.now()});
                let filesData = [{
                    file,
                    screenshot: "",
                    title: fileName,
                    type: "rec"
                }];
                this.addMedia2Project(filesData);
                soundRecorder.destroyRecorder();
            }
        },
        addMedia2Project(filesData){
            console.log("files data:",filesData);
            filesData.forEach(config => {
                this.uploadFile(config).then(res => {
                    if(!res.metadata){
                        let sId = res.sId;
                        setTimeout(() => {
                            this.uploadingMedias = this.uploadingMedias.filter(item => item.sId !== sId);
                        }, 400);
                        this.$message.error(this.$t("message.error_upload_file"));
                        return;
                    }
                    let {sId} = res;
                    setTimeout(() => {
                        this.uploadingMedias = this.uploadingMedias.filter(item => item.sId !== sId);
                        let materials =  this.materials.slice(0);
                        materials.unshift(res);
                        this.$store.commit("UPDATE_PROJECT_DATA", {
                            materials
                        })
                    }, 400);

                }).catch(err => {
                    let sId = err.sId || "";
                    setTimeout(() => {
                        this.uploadingMedias = this.uploadingMedias.filter(item => item.sId !== sId);
                    }, 400);
                    this.$message.error(this.$t("message.error_upload_file"));
                })
            })
        },
        uploadFile(config){
            return new Promise((resolve, reject) => {
                const {clientId} = this.b$.tool.store;
                const {type, file, title, screenshot} = config;
                const ver = "v1";
                let cmd, data = {
                    ver,
                    clientId,
                    customerId: this.teamId,
                    type,
                    title,
                    projectId: this.projectId || ""
                };
                cmd = "upload_proj_material";
                this.b$.send("tool", {
                    cmd,
                    data
                }, res => {
                    let data = res.data;
                    let {state, sId} = data;
                    let uploadMedia = this.getUploadMeidaBySId(sId);
                    if(state === "todo"){
                        let fileReader = new FileReader();
                        console.log("upload media sId :",sId);
                        this.uploadingMedias.unshift({
                            sId,
                            mediaType: this.type,
                            screenshot,
                            percent: 0,
                            status: null,
                            metadata: {
                                title: config.title
                            }
                        });
                        console.log("uploadingMedias:",this.uploadingMedias);
                        fileReader.onload = () => {
                            this.b$.sendBinary("tool", {
                                from: clientId,
                                to: "server",
                                sId,
                                sourceName: file.name,
                                destinationName: file.name,
                                size: file.size
                            }, fileReader.result, progress => {
                                let {data, eventName} = progress;
                                let uploadMedia = this.getUploadMeidaBySId(data.sid);
                                if(uploadMedia){
                                    let percent;
                                    if(eventName === "ftp_send_progress"){
                                        percent = parseInt(data.current / data.size * 100);
                                    } else if(eventName === "ftp_send_end"){
                                        percent = 100;
                                    }
                                    uploadMedia.percent = percent;
                                }
                            });
                        }
                        fileReader.readAsArrayBuffer(file);
                    }  else if(data.state === "done"){
                        if(uploadMedia){
                            uploadMedia.status = "success";
                        }
                        resolve(data);
                    } else {
                        
                        if(uploadMedia){
                            uploadMedia.status = "exception";
                        }
                        reject(data);
                    }
                });
            });
        },

        getUploadMeidaBySId(sId){
            return this.uploadingMedias.find(item => item.sId === sId);
        },
        
        beforeDeleteMaterial(material) {
            let message = this.$t("message.warn_before_delete_media");
            this.$confirm(message, this.$t("popper_title.tips"), {
                confirmButtonText: this.$t("button.ok"),
                cancelButtonText: this.$t("button.cancel"),
                type: "warning",
                customClass: "codelab-important-tip",
                cancelButtonClass: "codelab-button gray",
                confirmButtonClass: "codelab-button blue"
            }).then(() => {
                let { projectMaterialId } = material;
                const { clientId} = this.b$.tool.store;
                const ver = "v1";
                let cmd, data = {
                    ver,
                    clientId,
                    customerId: this.teamId,
                    projectId: this.projectId,
                    projectMaterialId: [projectMaterialId]
                };
                cmd = "del_proj_material";
                this.b$.send("tool", {
                    cmd,
                    data
                }, res => {
                    if(res.status && res.status.code === "0"){
                        let materials =  this.materials.slice(0).filter(item => item.projectMaterialId !== projectMaterialId);
                        if(this.selectedMedia && this.selectedMedia.projectMaterialId === projectMaterialId){
                            this.selectedMedia = null;
                        }
                        this.$store.commit("UPDATE_PROJECT_DATA", {
                            materials
                        })
                    } else {
                        this.$message.error("message.error_delete_media");
                    }
                })
            }).catch(() => {});
        },
        isVideo(url){
            return /\.(mp4|webm|mpg|mpeg)/.test(url)
        },
        isImg(url){
            return /\.(jpg|jpeg|png|gif)/.test(url)
        },
        isAudio(url){
            return /\.(ogg|wav|mp3)/.test(url)
        },
        isRecord(url){
            return /\.(ogg|wav|mp3)/.test(url)
        },
        getMaterialFormat(material){
            return material.url.split(".").pop();
        },
        getDurationText(duration = 0){
            if(duration === null || duration === undefined){
                return null;
            }
            duration /= 1000;
            let hour = Math.floor(duration / 3600);
            duration -= 3600 * hour;
            let minu = Math.floor(duration / 60);
            duration -= minu * 60;
            let sec = Math.ceil(duration);
            minu = minu < 10 ? "0" + minu : minu;
            sec = sec < 10 ? "0" + sec : sec;
            return `${hour}:${minu}:${sec}`;
        },
        getMaterialTitle(material){
            const langCode = Cookies.get("langCode");
            if(material.metadata && material.metadata.i18n){
                let langItem = material.metadata.i18n.find(item => item.langCode === langCode);
                if(langItem){
                    return langItem.name || langItem.description;
                }
            }
            return material.metadata.title || material.index || "";
        },
        getCustomMediaBlockIndexs() {
            if (this.workSpace) {
                let blocks;
                let customMediaIndexs = [];
                this.customMediaBlockTypes.forEach(type => {
                    blocks = this.workSpace.getBlocksByType(type);
                    blocks.forEach(block => {
                        let blockData = block.getFieldValue("input1");
                        blockData = blockData.split(".").shift();
                        if(blockData){
                            customMediaIndexs.push(blockData);
                        }
                    });
                });
                return customMediaIndexs;
            }
            return [];
        },
    },
    components: {
        addMaterialPopper,
        mediaUploader,
        soundRecord
    }
}
</script>

<style lang="scss">
    .el-dialog.codelab-media-manager{
        .el-dialog__body{
            width: 100%;
            height: 320px;;
            padding: 0;
            white-space: nowrap;
            font-size: 0px;
            .media-list-wrapper{
                border-radius: 0px;
            }
            .media-container{
                display: inline-block;
                width: 100%;
                height: 100%;
                background: #444444;
                transition: all ease-in 0.3s;
                vertical-align: top;
                .media-list-wrapper{
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    .el-scrollbar__wrap{
                        overflow-x: hidden;
                        .media-list{
                            width: 100%;
                            overflow: hidden;
                            li{
                                width: 156px;
                                height: 126px;
                                overflow: hidden;
                                margin: 12px 15px 0 15px;
                                line-height: 94px;
                                text-align: center;
                                font-size: 0;
                                float: left;
                                position: relative;
                                &.add-item{
                                    background: none;
                                    .add-custom-media{
                                        display: inline-block;
                                        width: 100%;
                                        height: 94px;
                                        font-size: 0;
                                        background: #272727;
                                        &:hover{
                                            background: rgba(14, 211, 255, 0.6);

                                        }
                                        .button{
                                            display: inline-block;
                                            width: 120px;
                                            height: 100%;
                                            line-height: 94px;
                                            color: #a8a8ac;
                                            cursor: pointer;
                                            svg{
                                                margin-left: -2px;
                                                margin-top: -2px;
                                                stroke: #a8a8ac;
                                                fill:  #a8a8ac;
                                            }
                                            &:hover{
                                                color: #333333;
                                                svg{
                                                    stroke: #333333;
                                                    fill: #333333;
                                                }
                                            }
                                        }
                                        
                                    }
                                }
                                .media-thumb{
                                    width: 100%;
                                    height: calc(100% - 32px);
                                    position: relative;
                                    background: #eaeaea;
                                    
                                    overflow: hidden;
                                    &>img{
                                        width: 100%;
                                        height: 100%;
                                        z-index: 2;
                                        position: absolute;
                                        left: 0;
                                        top: 0;
                                        object-fit: cover;
                                    }
                                    &>svg{
                                        position: absolute;
                                        left: 50%;
                                        top: 50%;
                                        transform: translate(-40px,-40px);
                                        z-index: 0;
                                        fill: #ffffff;
                                    }
                                }
                                
                                .media-name{
                                    width: 100%;
                                    height: 32px;
                                    line-height: 32px;
                                    font-size: 14px;
                                    color: #ffffff;
                                    text-align: center;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }
                                .delete-media{
                                    display: inline-block;
                                    width: 24px;
                                    height: 24px;
                                    line-height: 24px;
                                    text-align: center;
                                    cursor: pointer;
                                    z-index: 2;
                                    svg{
                                        fill: #333333;
                                    }
                                    &:hover {
                                        svg {
                                        fill: #696969;
                                        }
                                    }
                                    &:active {
                                        svg {
                                        fill: #45e5f4;
                                        }
                                    }
                                }
                            }
                            &.card{
                                border: 1px solid transparent;
                                padding: 20px;
                                li.selected{
                                    .media-thumb{
                                        border: 2px solid #3399ff;
                                    }
                                }
                                .delete-media{
                                    position: absolute;
                                    top: 8px;
                                    left: 8px;
                                }
                            }
                            &.list{
                                li{
                                    width: 100%;
                                    height: 45px;
                                    margin: 0;
                                    line-height: 45px;
                                    &:nth-child(even){
                                        background: #444444;
                                    }
                                    &:nth-child(odd){
                                        background: #272727;
                                    }
                                    &.add-item{
                                        width: 100%;
                                        height: 110px;
                                        line-height: 90px;
                                        
                                        .add-custom-media{
                                            width: 50%;
                                            height: 100%;
                                            text-align: center;
                                            .button{
                                                line-height: 50px;
                                                margin-top: 20px;
                                                .label{
                                                    display: block;
                                                    font-size: 12px;
                                                    line-height: 16px;
                                                }
                                            }
                                            
                                        }
                                    }
                                    &.selected{
                                        
                                        
                                        
                                        background: #111111;
                                        &>span{
                                            color: #1BD3FF;
                                        }
                                    }
                                    &>span{
                                        text-align: left;
                                        display: inline-block;
                                        font-size: 14px;
                                        color: #ffffff;
                                        padding: 0 6px;
                                        position: relative;
                                        vertical-align: middle;
                                        &.delete{
                                            width: 55px;
                                        }
                                        &.name{
                                            width: 320px;
                                            overflow: hidden;
                                            text-overflow: ellipsis;
                                            white-space: nowrap;
                                        }
                                        &.format{
                                            width: 106px;
                                        }
                                        &.duration{
                                            width: calc(100% - 55px - 106px - 320px);
                                        }
                                        &.name,&.format{
                                            &::after{
                                                content: "";
                                                display: block;
                                                position: absolute;
                                                height: 100%;
                                                width: 0;
                                                top: 0;
                                                right: 0px;
                                                border-right: 1px solid #696969;
                                            }
                                        }
                                    }
                                    
                                }
                                .list-header{
                                    height: 24px;
                                    padding: 4px 0;
                                    line-height: 16px;
                                    font-size: 0;
                                    &>span{
                                        font-size: 12px;
                                        color: #a8a8ac;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        
    }
</style>